import _ from 'lodash';

import { getGa } from 'core/googleAnalytics';

type EventCategory = 'DETAILS' | 'OPENING_TIMES' | 'SPECIAL_HOURS';

type EventAction =
  | 'ADD_OPENING_TIMES_ENTRY'
  | 'ADD_SPECIAL_HOURS_ENTRY'
  | 'CANCEL_OPENING_TIMES_EDITING'
  | 'CANCEL_SPECIAL_HOURS_EDITING'
  | 'CHANGE_SPECIAL_HOURS_DATE_MODE'
  | 'EDIT_OPENING_TIMES'
  | 'EDIT_PHONE_NUMBER'
  | 'EDIT_SPECIAL_HOURS'
  | 'EDIT_WEBSITE'
  | 'REMOVE_OPENING_TIMES_ENTRY'
  | 'REMOVE_SPECIAL_HOURS_ENTRY';

type ReportPayload = {
  hitType: 'event';
  eventCategory: EventCategory;
  eventAction: EventAction;
  eventLabel?: string;
};

const report = (payload: ReportPayload) => {
  const ga = getGa();

  if (!_.isFunction(ga)) {
    return;
  }

  ga('send', payload);
};

export const reportOpeningTimesEdit = (hasSpecialHours: boolean) => {
  report({
    hitType: 'event',
    eventCategory: 'OPENING_TIMES',
    eventAction: 'EDIT_OPENING_TIMES',
    eventLabel: hasSpecialHours ? 'hadSpecialHours' : undefined,
  });
};

export const reportOpeningTimesEditCancel = () => {
  report({
    hitType: 'event',
    eventCategory: 'OPENING_TIMES',
    eventAction: 'CANCEL_OPENING_TIMES_EDITING',
  });
};

export const reportOpeningTimesEntryAdd = () => {
  report({
    hitType: 'event',
    eventCategory: 'OPENING_TIMES',
    eventAction: 'ADD_OPENING_TIMES_ENTRY',
  });
};

export const reportOpeningTimesEntryRemove = () => {
  report({
    hitType: 'event',
    eventCategory: 'OPENING_TIMES',
    eventAction: 'REMOVE_OPENING_TIMES_ENTRY',
  });
};

export const reportSpecialHoursEdit = () => {
  report({
    hitType: 'event',
    eventCategory: 'SPECIAL_HOURS',
    eventAction: 'EDIT_SPECIAL_HOURS',
  });
};

export const reportSpecialHoursEditCancel = () => {
  report({
    hitType: 'event',
    eventCategory: 'SPECIAL_HOURS',
    eventAction: 'CANCEL_SPECIAL_HOURS_EDITING',
  });
};

export const reportSpecialHoursEntryAdd = () => {
  report({
    hitType: 'event',
    eventCategory: 'SPECIAL_HOURS',
    eventAction: 'ADD_SPECIAL_HOURS_ENTRY',
  });
};

export const reportSpecialHoursEntryRemove = () => {
  report({
    hitType: 'event',
    eventCategory: 'SPECIAL_HOURS',
    eventAction: 'REMOVE_SPECIAL_HOURS_ENTRY',
  });
};

export const reportSpecialHoursDateModeChange = (mode: 'period' | 'single') => {
  report({
    hitType: 'event',
    eventCategory: 'SPECIAL_HOURS',
    eventAction: 'CHANGE_SPECIAL_HOURS_DATE_MODE',
    eventLabel: mode,
  });
};

export const reportPhoneNumberEdit = () => {
  report({
    hitType: 'event',
    eventCategory: 'DETAILS',
    eventAction: 'EDIT_PHONE_NUMBER',
  });
};

export const reportWebsiteEdit = () => {
  report({
    hitType: 'event',
    eventCategory: 'DETAILS',
    eventAction: 'EDIT_WEBSITE',
  });
};
